<ng-template #tooltipSafetyHints>
    <osc-default-tooltip>
        {{ title }}
    </osc-default-tooltip>
</ng-template>
<sew-tag
    size="xs"
    [type]="type"
    icon="information"
    (click)="$event.stopPropagation(); openSafetyHintDialog()"
    [oscTooltip]="tooltipSafetyHints"
    [tooltipPositions]="['right']"
>
    {{ title }}
</sew-tag>
